import React from 'react';
import { ButtonToolbar } from 'reactstrap';
import TableToolbar from '../../../common/TableToolbar';
import { NEW_TOLL_LIQUIDATION_PATH } from '../../../../config/paths';

const TollLiquidationsTollbar = () => (
  <ButtonToolbar className="pull-right">
    <div>
      <TableToolbar
        buttonPath={NEW_TOLL_LIQUIDATION_PATH}
        buttonText="Crear"
        buttonClassName="btn btn-success"
      />
    </div>
  </ButtonToolbar>
);

export default TollLiquidationsTollbar;
